module.exports = __webpack_public_path__ + "fonts/AvenirBlack.2fe5091d.ttf";